import { useAuth } from '../../store/authStore';

interface UseDevelopmentWarningBannerReturn {
  shouldShowWarning: boolean;
}

export const useDevelopmentWarningBanner =
  (): UseDevelopmentWarningBannerReturn => {
    const { organization } = useAuth();

    const isDevelopment = import.meta.env.MODE === 'development';
    const isProductionCredentials =
      organization?.name === 'Wise Capital Production';

    const shouldShowWarning = isDevelopment && isProductionCredentials;

    return {
      shouldShowWarning,
    };
  };
